






















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';
import { Picker, Popup, Toast } from 'vant';
import { share } from '../api';
import Rule from '../components/Rule.vue';
import { watch } from 'vue';

Vue.use(Picker).use(Popup);
@Component({
  components: {
    VoteList,
    Rule,
  },
})
export default class Home extends Vue {
  showRules = false;
  showPicker = false;
  rankCondition = '人气作品';
  columns = ['人气作品', '最新作品'];
  active = 1;
  activeId = 0;
  tempValue = '';
  searchWords: any = '';
  sizetop = 0;
  sizetop1 = 0;
  status1 = true;
  ischangetype = false;
  intonowx = false;
  tabs = [
    {
      id: 1,
      default: require('../assets/sendhappyness.png'),
      desc:
        '春节是中国最重要的传统节日之一，承载了丰富的文化内涵和历史传统。广大未成年人家庭在春节期间学习传承优秀传统文化，开展家庭同庆、亲子共游等活动，一起逛庙会、办年货、赏民俗，体验写春联、挂灯笼、剪窗花、贴门神等春节习俗，了解民俗的由来和其中蕴含的文化。',
    },
    {
      id: 3,
      default: require('../assets/newyear.png'),
      desc:
        '各式春节美味佳肴是春节万家团圆时的情感纽带，寄托着人们对家的依恋和热爱。广大未成年人树立劳动意识，增强动手能力，学习制作包汤圆、包饺子、做年糕等春节美食，参与年夜饭的准备过程，了解春节美食背后的文化和寓意，感悟亲情亲恩。',
    },
    {
      id: 2,
      default: require('../assets/showfuture.png'),
      desc:
        '说吉祥语过吉祥年，春节拜年送祝福代表了人们对生活的美好希望和对盛世太平的美好祝愿。广大未成年人学习传承中华传统礼仪，向长辈、老师以及春节期间坚守岗位的环卫工人、医务人员、公安干警、消防战士等群体拜年送祝福，表达感恩之情。',
    },
  ];

  get tabClass() {
    return `tab-item-active` + this.active;
  }
  get type() {
    return this.tabs[this.active - 1].id;
  }
  // @Watch('activeId', { immediate: true })
  // changeactiveId() {
  //   this.mounted();
  // }
  created() {
    // window.addEventListener('scroll', this.scrollToTop);
    if (this.$route.query.search) {
      this.searchWords = this.$route.query.search;
    }
    if (
      window.localStorage.getItem('sweetTigernowid') &&
      window.localStorage.getItem('sweetTigernowtype')
    ) {
      this.activeId = parseInt(
        window.localStorage.getItem('sweetTigernowid') + '',
      );
      window.localStorage.removeItem('sweetTigernowid');
      this.active = parseInt(
        window.localStorage.getItem('sweetTigernowtype') + '',
      );
      window.localStorage.removeItem('sweetTigernowtype');
      // console.log('activeid:', this.activeId, this.active);
      if (this.active === 2) {
        this.active = 3;
      } else if (this.active === 3) {
        this.active = 2;
      }
    }
    console.log('---1--:', this.status1, this.activeId, this.active);

    if (this.status1 && this.activeId && this.active) {
      setTimeout(() => {
        console.log('---2--:', this.status1, this.activeId, this.active);
        window.scrollTo(0, 0);
        this.sizetop = (this.$refs.scrosize as any).offsetTop;
        this.status1 = false;
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        // console.log('scrollTop:', scrollTop, this.sizetop);
        const leftnum = scrollTop - this.sizetop;
        const sizetop1 = (document.querySelector(
          `div[arch=${'to' + this.activeId}]`,
        ) as any).offsetTop;
        const heightsize = (document.querySelector(
          'div[class="VoteList-one"',
        ) as any).offsetHeight;
        // console.log('prossit:', 0, sizetop1 + leftnum + heightsize + 20);
        window.scrollTo(0, sizetop1 + leftnum + heightsize + 20);
        console.log('----1----:', sizetop1 + leftnum + heightsize + 20);
      }, 5000);
      // setTimeout(() => {

      // }, 3000);
    }
  }
  handleClickTab(index: number) {
    if (this.ischangetype) {
      Toast({
        type: 'fail',
        duration: 1000,
        message: '点击太快~',
      });
      return;
    }
    // this.tempValue = '';
    this.active = index + 1;
    this.rankCondition = '人气作品';
    this.ischangetype = true;
    setTimeout(() => {
      this.ischangetype = false;
    }, 1000);
  }
  handleClickSearch() {
    this.searchWords = this.tempValue;
    // this.searchWords = (this.$refs.input as HTMLInputElement).value;
  }
  enterDetailPage(id: number, index: number) {
    // console.log('id:', id, 'index:', index);
    this.status1 = true;
    this.$router.push({
      path: 'detail',
      query: {
        id: String(id),
        index: String(index),
        type: String(this.type),
      },
    });
  }
  onConfirm(e: any) {
    this.rankCondition = e;
    this.showPicker = false;
  }
  jumpToUserCenter() {
    // console.log('进来了');
    this.$router.push('user');
  }

  ruleClose() {
    this.showRules = false;
  }

  goRules() {
    if (this.active === 1) {
      this.$router.push('rule?scroll=true');
    }
  }

  gotoOutUrl() {
    window.location.href =
      'https://wap.cqcb.com/shangyou_news/SpecialPage?classId=9826';
  }
}
